<h2 mat-dialog-title>
  {{ 'scheduler.setup.roster.divisionDelete.title' | translate }}
</h2>

<mat-dialog-content>
  <p>Are you sure you want to delete this division?</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="cancel()" mat-button>Cancel</button>
  <button (click)="confirm()" color="warn" mat-raised-button>Delete</button>
</mat-dialog-actions>
